import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageTrackingCredentialsPanel extends Layout {
    TTCredentialsPanel: Panel;
    macropointCredentialsPanel: Panel;
    panelFourKites: Panel;
    panelMacroPointFieldContainer: Panel;
    project44CredentialsPanel: Panel;
    sourceBrTrackingCtrl: DataSource;
    textboxAccountID: Textbox;
    textboxFourKitesAccountID: Textbox;
    textboxFourKitesPassword: Textbox;
    textboxFourKitesUrl: Textbox;
    textboxMacropointUrl: Textbox;
    textboxMcNumber: Textbox;
    textboxP44Password: Textbox;
    textboxP44Url: Textbox;
    textboxPassword: Textbox;
    textboxProject44AccountID: Textbox;
    textboxTruckerToolsAccountID: Textbox;
    textboxTruckerToolsUrl: Textbox;
    textboxWebPassword: Textbox;
    textboxWebUser: Textbox;
}
